import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";

const useLicenseFilterOptions = () => {
  const { licenseService } = useGlobalContext();

  return useQuery(["licenseService.getLicenseFilterOptions"], () =>
    licenseService.getLicenseFilterOptions(),
  );
};

export default useLicenseFilterOptions;
